<template>
  <section>


  </section>
</template>
<script>
export default {
  data() {
    return {
      payMethod: 0,
      user: this.$store.state.auth.user
    };
  },
  methods: {
    setActie(id)
    {
      this.payMethod = id;
    }
  },
  mounted: function() {}
};
</script>
<style>
</style>